export enum VehiclesTab {
  All = "all",
  Owner = "owner",
  Shared = "shared",
}
